// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"891f5f2cd505b690","9777":"f3fcdd459941b84e"}[chunkId] + ".js";
};